<template>
  <div>
    <div class="third-rea">
      <div class="third-btn">
        <div class="btn-left">检索条件</div>
        <div class="btn-right">
          <el-button class="btn-two" type="primary" @click="searchInput">查询</el-button>
          <el-button class="btn-two" type="default" @click="resetInput">重置</el-button>
          <span class="btn-shu"></span>
          <el-button class="btn-four" type="default" icon="el-icon-search" @click="hignSearch">高级检索</el-button>
        </div>
      </div>
      <div class="third-search">
        <el-form :inline="true" :model="formInline" label-width="85px" @keyup.native.enter="searchInput">
          <div class="search-row">
              <div class="row-item">
                <el-form-item label="账号">
                  <el-input class="item-input" :maxlength="30" v-model="formInline.account" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
              <div class="row-item">
                <el-form-item label="姓名">
                  <el-input class="item-input" :maxlength="30" v-model="formInline.realName" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
              <div class="row-item">
                <el-form-item label="身份">
                  <el-select class="item-input" v-model="formInline.identity" clearable placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="学生" value="STUDENT"></el-option>
                    <el-option label="老师" value="TEACHER"></el-option>
                    <el-option label="其他" value="OTHER"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="row-item">
                <el-form-item label="角色">
                  <el-select class="item-input" v-model="formInline.roleId" clearable placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option 
                      v-for="(item, index) in roleList"
                      :key="index"
                      :label="item.roleName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="row-item">
                <el-form-item label="紧急联系人数">
                  <el-select class="item-input" v-model="formInline.emergencyNumber" clearable placeholder="请选择">
                    <el-option label="0" value="0"></el-option>
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="4" value="4"></el-option>
                    <el-option label="5" value="5"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="row-item">
                <el-form-item label="更新时间">
                  <el-date-picker
                    v-model="formInline.updateTime"
                    type="daterange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="right"
                    :default-time="['00:00:00', '23:59:59']">
                  </el-date-picker>
                </el-form-item>
              </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="third-one deviceManage">
      <div class="third-do-btn">
        <div class="do-btn-right">
          <div class="do-btn-check">
            <el-checkbox class="btn-check-item" v-model="checked" @change="changeHign"></el-checkbox>
            <span class="btn-check-span">显示高级功能</span>
          </div>
          <div class="do-btn-hign-list" v-if="checked">
            <!-- 展示字段 -->
            <sort-data
              :tableRow="tableRow"
              @showList="getTableList"
              sessionOriginalName="contactsMannageSortOrignalData"
              sessionResultName="contactsMannageListSortData"
            ></sort-data>
            <!-- 数据顺序 -->
            <display-field
              :selectList="tableRow"
              sessionOriginalName="contactsMannageDisplayFiedOrignal"
              @setDataOrder="getDataOrder"
              sessionResultName="contactsMannageDisplayFied"
            ></display-field>
          </div>
        </div>
      </div>
      <el-table
        class="third-tableThree tableThree-heightOth"
        :data="tableData"
        border
        stripe
        v-loading="loading"
        @selection-change="handleSelectChange"
        row-key="otherUserId"
        ref="otherUserId"
        >
        <el-table-column
          type="selection"
          width="32px"
          reserve-selection>
        </el-table-column>
        <template v-for="(item, index) in tableDataShow">
          <el-table-column
            min-width="100px"
            :prop="item.key"
            :label="item.column"
            :key="index"
            :show-overflow-tooltip="true">
             <template slot-scope="scope">
                 {{ getlable(scope.row, item.key) }}
             </template>
          </el-table-column>
        </template>
        <el-table-column min-width="50px" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button @click="changeComponent(scope.row)" type="text" size="small">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="third-page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum">
        </el-pagination>
      </div>
    </div>
    <hign-modal :hignModalVisible="hignModal" @searchModal="toHignSearch" @cancelModal="closeModal" :hignOneList="tableRow"></hign-modal>

  </div>
</template>

<script>
import { getStore, setStore } from "@/utils/store";

export default {
  name: 'thirdThree',
  data() {
    return {
      loading: false,
      detailModal: false, // 详情弹窗
      noticeDispatch: '', // 弹窗提交类型 status: 状态 del：删除
      pageSize: 40,
      pageIndex: 1,
      totalNum: 0, // 总数
      tableData: [],
      hignModal: false, // 高级搜索
      formInline: {
        account: '',
        realName: '',
        identity: '',
        updateTime: [],
        sex: '',
        roleId: '',
        emergencyNumber: '',
      },
      selectArrList: [], // 批量移除
      nowSelectArr: [], // 移除数组
      isDeleteList: false, // 是否批量删除
      hignSearchRes: '', // 高级检索条件
      tableDataShow: [
        {
          column: '账号',
          key: 'account',
          needKeyValue: true,
          caseKey: 'account'
        },
        {
          column: '姓名',
          key: 'realName',
          needKeyValue: false,
          caseKey: 'realName'
        },
        {
          column: '性别',
          key: 'sex',
          needKeyValue: false,
          caseKey: 'sex'
        },
        {
          column: '身份',
          key: 'identity',
          needKeyValue: false,
          caseKey: 'identity'
        },
        {
          column: '角色',
          key: 'roleId',
          needKeyValue: false,
          caseKey: 'roleId'
        },
        {
          column: '紧急联系人数（个）',
          key: 'emergencyNumber',
          needKeyValue: false,
          caseKey: 'emergencyNumber'
        },
        {
          column: '更新时间',
          key: 'updateTime',
          needKeyValue: false,
          caseKey: 'updateTime'
        },
      ],
      orderConfig: '', // 字段展示和顺序需要的参数
      checked: true,
      statusData: {}, // 状态params
      delId: '', // 删除ID
      tableRow: [ // 所有字段
        {
          column: '账号',
          key: 'account',
          needKeyValue: true,
          caseKey: 'account'
        },
        {
          column: '姓名',
          key: 'realName',
          needKeyValue: false,
          caseKey: 'realName'
        },
        {
          column: '性别',
          key: 'sex',
          needKeyValue: false,
          caseKey: 'sex',
          isCustomList: [
              {
              label: '男',
              value: '1'
              },
              {
              label: '女',
              value: '2'
              }
          ]
        },
        {
          column: '身份',
          key: 'identity',
          needKeyValue: false,
          caseKey: 'identity',
          isCustomList: [
              {
              label: '学生',
              value: 'STUDENT'
              },
              {
              label: '教工',
              value: 'TEACHER'
              },
              {
              label: '其他',
              value: 'OTHER'
              }
          ]
        },
        {
          column: '角色',
          key: 'roleId',
          needKeyValue: false,
          caseKey: 'roleId',
          isCustomList: [],
        },
        {
          column: '紧急联系人数（个）',
          key: 'emergencyNumber',
          needKeyValue: false,
          caseKey: 'emergencyNumber'
        },
        {
          column: '更新时间',
          key: 'updateTime',
          needKeyValue: false,
          caseKey: 'updateTime'
        },
      ]
    }
  },
  computed: {
    roleList() {
      const { roleList } = this.$store.state.deviceMan;
      // console.log(roleList)
      if (roleList) {
        return roleList
      }
      return []
    }
  },
  created() {
    this.tableRow[4].isCustomList = this.roleList.map( (item) => {
      return {
        value: item.id,
        label: item.roleName
      }
    })
    // console.log(this.tableRow)
    const dispField = this.getSessonValue("contactsMannageDisplayFied");
    const tableRow = this.getSessonValue("contactsMannageListSortData");
    if (dispField) {
      this.orderConfig = dispField;
    }
    if (tableRow) {
      this.tableDataShow = tableRow;
    } else {
      this.tableDataShow = this.tableRow;
    }
    this.getTableData()
    this.init();
  },
  methods: {
    changeComponent(rowData) {
      setStore({
        name: "rowData",
        content: rowData,
        type: "session"
      });
      this.$emit("changeComponent", 'detailsInfo');
    },
    init() {
      this.$store.dispatch('platformalumniuserRoleList');
    },
    getSessonValue(name) {
      return getStore({
        name: name,
        type: "session"
      });
    },
     // 高级检索
    toHignSearch(res) {
      console.log(res)
      this.hignSearchRes = res
      this.hignModal = false
      this.pageIndex = 1;
      this.getTableData();
    },
    // 搜索
    searchInput() {
      this.hignSearchRes = ''
      this.pageIndex = 1
      this.getTableData()
    },
    // 重置
    resetInput() {
      this.hignSearchRes = ''
      this.pageIndex = 1
      Object.keys(this.formInline).forEach((key) => {
        this.formInline[key] = '';
      })
      this.getTableData()
    },
    // 批量选中项变化
    handleSelectChange(selection) {
      console.log(selection)
      this.selectArrList = selection
    },
    // 返回上级
    goBack() {
      this.$emit('backHome')
    },
    // 关闭弹窗
    closeModal() {
      this.hignModal = false;
    },
    // 显示高级或者不显示
    changeHign() {
      console.log(this.checked);
    },
    // 切换展示字段
    getTableList(value) {
      this.tableDataShow = value;
    },
    // 改变数据排序
    getDataOrder(value) {
      this.orderConfig = value;
      console.log("改变了数据顺序", this.orderConfig);
      this.getTableData();
    },
    // 高级检索
    hignSearch() {
      this.hignModal = true
    },
    handleSizeChange(val) {
      this.pageIndex = 1
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getTableData()
    },
    // 查询列表
    async getTableData() {
      let dataSortStr = this.orderConfig;
      if (Array.isArray(this.orderConfig)) {
        dataSortStr = this.orderConfig.join(",");
      }
      const startTime = this.formInline.updateTime[0] ? this.formInline.updateTime[0] : '';
      const endTime = this.formInline.updateTime[1] ? this.formInline.updateTime[1] : '';
       this.loading = true
      const serviceList = await this.$store.dispatch('getEmergencyList', {
        iEmergencyVO: {
          account: this.formInline.account,
          realName: this.formInline.realName,
          identity: this.formInline.identity,
          sex: this.formInline.sex,
          startTime: startTime,
          endTime: endTime,
          roleId: this.formInline.roleId,
          emergencyNumber: this.formInline.emergencyNumber,
        },
        dataSortStr: dataSortStr, //数据排序
        advancedSearch: this.hignSearchRes,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      })
      this.loading = false
      const { records } = serviceList.data.result;
      if (serviceList.data.status === 1000) {
        if (records.length !== 0) {
          this.tableData = records
          this.totalNum = Number(serviceList.data.result.total)
        } else {
          if (this.pageIndex !== 1) {
            this.pageIndex -= 1
            this.getTableData()
          } else {
            this.tableData = []
            this.totalNum = 0
          }
        }
      } else {
        this.tableData = []
        this.totalNum = 0
      }
    },
    getlable(row, key) {
      let value = row[key];
      switch (key) {
        case 'identity':
          if (row[key] === 'STUDENT') {
            value = '学生';
          } else if (row[key] === 'TEACHER') {
            value = '老师';
          } else if (row[key] === 'OTHER') {
            value = '其他';
          }
          break;
        case 'sex':
          if (row[key] === 1) {
            value = '男';
          } else if (row[key] === 2) {
            value = '女';
          } else if (row[key] === 3) {
            value = '其他';
          }
          break;
        case 'roleId':
          if(row['roleId'] == undefined){
            value = '';
            break;
          }
          let roleArr = row['roleId'].split(',');
          roleArr = roleArr.filter(item => item)
          let roleNameArr = []
          if (roleArr.length > 0) {
            roleArr.forEach(element => {
              const [role] = this.roleList.filter(item => element == item.id)
              if (role) roleNameArr.push(role.roleName);
            })
          }
          value = roleNameArr.join('，')
          break;
        default:
          value = row[key];
          break;
      }
      return value;
    },
  }
}
</script>

<style lang="scss">
.deviceManage {
  height: calc(100vh - 122px);
}
.tableThree-heightOth {
  .el-table__body-wrapper {
    height: calc(100vh - 239px) !important;
    .tableThree-height-shu {
      display: inline-block;
      padding: 0 4px;
      position: relative;
      .shu-item {
        position: absolute;
        width: 1px;
        height: 12px;
        background-color: #D4D4D7;
        display: inline-block;
        top: -10px;
      }
    }
  }
  .bigImg {
    color:#2D8CF0;
    cursor: pointer;
  }
  .redCorlo {
    color: #FF4D4F;
  }
  .greenCorlo {
    color: #33CC99;
  }
}
.serviceDialog {
    text-align: center;
  img {
    max-width: 100%;
  }
  .el-dialog__body {
    padding: 10px 0 !important;
  }
}
.el-range-editor.el-input__inner {
  width: 216px;
}
</style>